import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// utils
import getUrl from "api/apiMap"

export const useGetStudyProtocolDataCompare = (authoringId) => {
  return useGetApi(
    authoringId ? getUrl(`${apiEndpoints.authoring}${authoringId}/protocol-data-compare`) : null,
    queryKeys.registriesDataCompare.details(authoringId)
  )
}

export const useGetStudyRegistryData = (authoringId) => {
  return useGetApi(
    authoringId ? getUrl(`${apiEndpoints.authoring}${authoringId}/protocol-reg-data`) : null,
    queryKeys.registriesData.details(authoringId)
  )
}

export const usePostPrsProtocolDownload = (authoringId) => {
  let url = `/authoring/api/v1/tasks/prs-protocol-download?stu-id=${authoringId}`
  let invalidateQueries = [...queryKeys.prsProtocol.list]
  let options = {}

  if (authoringId) invalidateQueries.push(queryKeys.prsProtocol.details(authoringId))
  if (authoringId) options = { params: { "stu-id": authoringId } }

  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(url),
    invalidateQueries,
    options: {
      params: {
        "stu-id": authoringId,
      },
    },
  })
}

export const useGetPrsProtocolUpload = ({ queueId, sitesOnly = false }, options) => {
  return useGetApi(getUrl(apiEndpoints.prsProtocolSiteUpload), queryKeys.pollingTask(queueId), options, {
    "queue-id": queueId,
    "sites-only": sitesOnly,
  })
}

export const usePostPrsProtocolUpload = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.prsProtocolSiteUpload),
    invalidateQueries: [],
    infoMsg: "PRS protocol upload in progress",
  })
}
